import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledContainer = styled.ul`
  margin: 0;

  li + li {
    margin-top: 5px;
  }
`;

const Message = ({ issues }) => (
  <StyledContainer data-test="issues">
    {issues.map(issue => (
      <li key={issue}>{`- ${issue}`}</li>
    ))}
  </StyledContainer>
);

Message.propTypes = {
  issues: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Message;
